import { action } from '@ember/object';

import { ReportFragmentAction, type NewReportSlideFragmentLayout } from 'webapp/enums/enums';

import type { ReportFragmentActionData } from 'webapp/components/reports/editor-base';
import ReportsFragmentGridAddFragmentButtonComponent from 'webapp/components/reports/fragment-grid/add-fragment-button';
import type { Args as BaseArgs } from 'webapp/components/reports/viewer/fragment/title';
import ReportsViewerFragmentTitleComponent from 'webapp/components/reports/viewer/fragment/title';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

interface Args extends BaseArgs {
	onFragmentChange: (
		fragment: ReportSlideFragment,
		action: ReportFragmentAction,
		data?: ReportFragmentActionData,
	) => Promise<unknown>;
}

export default class ReportsEditorFragmentPlaceholderComponent extends ReportsViewerFragmentTitleComponent<Args> {
	@action
	changeType(type: NewReportSlideFragmentLayout) {
		void this.args
			.onFragmentChange(this.args.model, ReportFragmentAction.CHANGE_TYPE, {
				layout: type,
			})
			.then(() => {
				// Reset height of the grid item if not stretchable
				if (!this.args.model.isStretchableOnSlide) {
					const gridItemNode = document.querySelector<HTMLElement>(
						`.grid-item[data-id="${this.args.model.id}"]`,
					)!;

					if (gridItemNode) {
						gridItemNode.style.height = '';
					}
				}
			});
	}
	<template>
		<div class="fragment fragment--placeholder">
			<ReportsFragmentGridAddFragmentButtonComponent
				@isVisible={{true}}
				@onAddFragment={{this.changeType}}
			/>
		</div>
	</template>
}
